import React, {useState, useRef, useEffect} from 'react';
import axios from 'axios';
import "./UploadSingleFile.css"
import {useLocation} from "react-router-dom";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import {Button, Checkbox,  FormControlLabel, TextField} from "@mui/material";
import {IoIosCloseCircle, IoMdEye, IoMdTrash} from "react-icons/io";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import CaseFilesInternal from "../../enums/CaseFilesInternal";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import DatePicker from "react-datepicker";
import {ka} from "date-fns/locale";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";

const UploadCertificateFile = ({onClose, onFileUpload, caseData, users}) => {
    const [file, setFile] = useState(null);
    const [shared, setShared] = useState(false);
    const [fileTitle, setFileTitle] = useState("ინსპექტირების სერტიფიკატის დოკუმენტი");
    const [inspectionSertificatIssuingAgency, setInspectionSertificatIssuingAgency] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = useRef(null);
    const [caseFileNumber, setCaseFileNumber] = useState('');
    const [sertificatReleaseDate, setSertificatReleaseDate] = useState(null);
    const [inspectionSertificatValidityPeriodDate, setInspectionSertificatValidityPeriodDate] = useState(null);
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const disableUpload = !file ||
        isUploading ||
        !fileTitle ||
        caseFileNumber === '' ||
        !inspectionSertificatIssuingAgency ||
        sertificatReleaseDate === null ||
        inspectionSertificatValidityPeriodDate === null
    const [roleId, setRoleId] = useState('');

    const handelDeleteMainFile = () => {
        fileInputRef.current.value = ''
        setFile(null)
    };

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true,

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.type !== 'application/pdf') {
                setAlert({show: true, message: 'შეცდომა: ატვირთეთ მხოლოდ PDF ფაილები.', type: 'error'});
                setFile(null);
            } else {
                setFile(selectedFile);
                setAlert({...alert, show: false});
            }
        }
    };


    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.key === "Escape") {
                onClose();
            }
        }


        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [onClose]);


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    const performUpload = async () => {
        if (!file) {
            return;
        }

        const payload = {

            caseId: caseId,
            inspectionDocumentCheckingDate: caseData.inspectionDocumentCheckingDate,
            inspectionDocumentmplementation: caseData.inspectionDocumentmplementation,
            inspectionSertificatValidityPeriodDate: inspectionSertificatValidityPeriodDate ? inspectionSertificatValidityPeriodDate.toISOString() : null
        };
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseSertificatAndInspectionInfo`, payload);
            if (!response.data.success) {
                return
            }
        } catch (error) {
            return
        }

        setIsUploading(true);
        const fileBase64 = await toBase64(file);
        const fileData = {
            caseID: caseId,
            name: fileTitle,
            ext: file.name.split('.').pop(),
            file: fileBase64,
            mainInfo: "",
            additionalInfo: '',
            shared: shared,
            sharedTemp: shared,
            blank: false,
            documentType: 0,
            internal: CaseFilesInternal.Yes,
            status: CaseFilesStatus.SentForVisage,
            decline: CaseFileDeclined.No,
            isUploaded: true,
            approvalDocument: false,
            declinedInternalStatus: 0,
            isSertificatFile: true,
            sertificatReleaseDate: sertificatReleaseDate ? sertificatReleaseDate.toISOString() : null,
            inspectionSertificatValidityPeriodDate: inspectionSertificatValidityPeriodDate ? inspectionSertificatValidityPeriodDate.toISOString() : null,
            inspectionSertificatIssuingAgency: inspectionSertificatIssuingAgency,
            caseFileNumber: caseFileNumber
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData);
            await sendNotification(response.data.resultId)
            setAlert({show: true, message: 'დოკუმენტი აიტვირთა წარმატებით!', type: 'success'});
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსირდა შეცდომა, ცადეთ მოგივანევბით!', type: 'error'});
        } finally {
            setIsUploading(false);
            setIsModalOpen(false);
            onFileUpload();
            onClose();
        }
    };


    return (
        <div>
            <div className="upload-single-popup">
                <div className="upload-single-container">
                    <IoIosCloseCircle className="upload-single-close-icon" onClick={onClose}>Close</IoIosCloseCircle>
                    <div className="upload-single-header">
                        <p className="upload-single-title">ინსპექტირების სერტიფიკატის დოკუმენტის ატვირთვა</p>
                    </div>
                    <div className="upload-single-body">
                        <Button variant="contained" onClick={() => fileInputRef.current.click()}
                                className="upload-single-button">
                            აირჩიეთ ფაილი
                        </Button>
                        <input
                            type="file"
                            accept=".pdf"
                            ref={fileInputRef}
                            style={{display: 'none'}}
                            onChange={handleFileChange}
                        />
                        {file && <div className="upload-single-selected-file">
                            <span>{file.name}</span>
                            <div className="file-actions">
                                <div style={{marginTop: 5}}>
                                    <IoMdEye
                                        className="file-icon preview-icon"
                                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                                    />

                                    <IoMdTrash
                                        className="file-icon delete-icon"
                                        onClick={handelDeleteMainFile}
                                    />
                                </div>
                            </div>
                        </div>}
                        <TextField
                            label="ფაილის სახელი"
                            variant="outlined"
                            type="text"

                            value={fileTitle}
                            onChange={(e) => setFileTitle(e.target.value)}
                        />
                        <TextField
                            type="text"
                            fullWidth
                            label="დოკუმენტის ნომერი"
                            variant="outlined"
                            value={caseFileNumber}
                            onChange={(e) => setCaseFileNumber(e.target.value)}
                            InputProps={{inputProps: {min: 1}}}
                        />
                        <TextField
                            label="გამცემი ორგანო"
                            variant="outlined"
                            type="text"
                            value={inspectionSertificatIssuingAgency}
                            onChange={(e) => setInspectionSertificatIssuingAgency(e.target.value)}
                        />




                        <div className="full-width">
                            <p>გაცემის თარიღი:</p>
                            <DatePicker
                                selected={sertificatReleaseDate}
                                onChange={(date) => setSertificatReleaseDate(date)}
                                locale={ka}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                dateFormat="dd/MM/yyyy"
                                placeholderText="აირჩიეთ თარიღი"
                                className="full-width"
                            />
                        </div>

                        <div className="full-width">
                            <p>გადამოწმების თარიღი:</p>
                            <DatePicker
                                selected={inspectionSertificatValidityPeriodDate}
                                onChange={(date) => setInspectionSertificatValidityPeriodDate(date)}
                                locale={ka}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                                placeholderText="აირჩიეთ თარიღი"
                                className="full-width"
                            />
                        </div>


                        <div className={"upload-single-checkbox-group"}>
                            <FormControlLabel
                                control={<Checkbox checked={shared} onChange={(e) => setShared(e.target.checked)}/>}
                                label="საჯარო"
                            />
                        </div>

                    </div>
                    <div className="upload-single-footer">
                        <Button style={{width: "100%"}} onClick={() => setIsModalOpen(true)}
                                disabled={disableUpload} variant="contained">
                            {isUploading ? 'ატვირთვა...' : 'დოკუმენტის ატვირთვა'}
                        </Button>
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={performUpload}
                />

            </div>
            {alert.show &&
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            }
        </div>

    );
};

export default UploadCertificateFile;
